// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

var module; UMD(module, {
  'minted:m': ['M']
})(this, function (m_module) {

var M = m_module.M;

M.String = M.String || {};

/**
 * Replaces a single character in a string.
 */
M.String.replaceAt = function(string, index, replacement) {
  var a = string.split("");
  a[index] = replacement;
  return a.join("");
};

M.String.startsWith = function(string, starter) {
  return string.substring(0, starter.length) === starter;
};

M.String.titleize = function(string) {
  return string.replace(/\w\S*/g, function(txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

/**
 * Exception thrown when the value being worked on is not a string
 *
 * @param {} obj The problematic value.
 */
M.String.NotStringException = function(message) {
  this.name = 'NotStringException';
  this.message = message | "The value is not a string";
};
M.String.NotStringException.prototype = new Error();
M.String.NotStringException.constructor = Error;

/**
 * Takes a variable amount of parameters and joins them with a newline.
 *
 * @param {String} arguments A variable amount of strings.
 *
 * @return {String} One string with all strings combined with newlines between
 * them.
 */
M.String.combineWithNewLine = function() {
  var i = 0,
      ilen = arguments.length,
      combinedString = '';

  if (arguments.length < 2) {
    throw new M.IllegalNumberOfArgumentsException(
      'Function requires more then 1 arguments', arguments);
  }

  for ( ; i < ilen; i++) {
    if (!_.isString(arguments[i])) {
      throw new M.String.NotStringException('Function requires all arguments ' +
                                            'to be strings: ' + arguments[i]);
    }
    combinedString += arguments[i] + (i < ilen - 1 ? "\n" : "");
  }

  return combinedString;
};

/**
 * Takes a string and splits it into two parts, making the split after the
 * first newline.
 *
 * @param {String} string The string to split at first newline.
 *
 * @return {Array} An array of the string split into two elements.
 */
// TODO Improve by allowing splits at different places or multiple splits?
M.String.splitAtFirstLine = function(string) {
  var first = '',
      rest = '',
      matches = '',
      firstLineRegex = /(^.*$)/gm;

  if (!string) {
    throw new M.IllegalNumberOfArgumentsException('Function requires at least ' +
                                                  'one string as an argument');
  }
  if (!_.isString(string)) {
    throw new M.String.NotStringException('The function requires the argument ' +
                                          'to be a string: ' + string);
  }

  matches = string.match(firstLineRegex);
  first = matches[0];
  rest = matches.slice(1).join("\n");

  return [first, rest];
};

/**
 * Cut the content to however many  lines. For example, RAP is cut to 4
 * lines only in CU3, so this function can be used to cut RAP to 4 lines.
 *
 * @param {String} string The string to cut.
 * @param {Number} numLines The lines to cut the content to.
 *
 * @return {String} String that's been cut to 4 lines.
 */
M.String.cutContentAtLines = function(string, numLines) {
  var stringSplit = string.split("\n");

  return stringSplit.slice(0, numLines).join("\n");

};

/**
 * Adds (totalNumChars - targetString.length + 1) of padChar to
 * the left of targetString
 *
 * @param {String} targetString the string to add chars to
 * @param {Number} totalNumChars the total number of chars
 * that the resultant string should have
 * @param {String} padChar character to padd with
 *
 * @return {String} String
 */
M.String.padLeft = function(targetString, totalNumChars, padChar) {
  var arrayLength = totalNumChars - String(targetString).length + 1;
  if (arrayLength > 0) {
    return Array(totalNumChars - String(targetString).length + 1).join(padChar || " ") + targetString;
  } else {
    return targetString;
  }
};

/**
 * Determines if a string contains only digits using regex matching
 * on d
 *
 * @param {String} string to test
 * @return {bool} true if string is only digits
 */
M.String.isOnlyDigits = function(testStr) {
  return (/^\d+$/).test(testStr);
};

return {};
});
